import { useFischer } from './fischerPlugin';

const DIST_PATH = '/dist/fischer-website-rebrush/';

/** Callers write the asset path root-relative, which the showroom wants and this base does not. */
const stripLeadingSlash = (asset: string) => asset.replace(/^\//, '');

// Composable version for use in Vue components
export const useAssetUrl = () => {
  const fischer = useFischer();

  const getAssetUrl = (asset: string) =>
    IS_SHOWROOM ? asset : `${fischer.hostUrlBase()}${DIST_PATH}${stripLeadingSlash(asset)}`;

  return { getAssetUrl };
};

// Standalone helper for use in utility files (requires fischer instance)
export const createGetAssetUrl = (hostUrlBase: string) => {
  return (asset: string) =>
    IS_SHOWROOM ? asset : `${hostUrlBase}${DIST_PATH}${stripLeadingSlash(asset)}`;
};
